// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrLockboxDtoDetails } from './IOcrLockboxDtoDetails';
import {
    IOcrLockboxDtoDetailsFromJSON,
    IOcrLockboxDtoDetailsFromJSONTyped,
    IOcrLockboxDtoDetailsToJSON,
    IOcrLockboxDtoDetailsToJSONTyped,
} from './IOcrLockboxDtoDetails';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';

/**
 * 
 * @export
 * @interface IOcrLockboxAggregatorDto
 */
export interface IOcrLockboxAggregatorDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrLockboxAggregatorDto
     */
    birth_date?: string;
    /**
     * 
     * @type {number}
     * @memberof IOcrLockboxAggregatorDto
     */
    amount?: number;
    /**
     * 
     * @type {IAddress}
     * @memberof IOcrLockboxAggregatorDto
     */
    address?: IAddress;
    /**
     * 
     * @type {Array<number>}
     * @memberof IOcrLockboxAggregatorDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {IOcrLockboxDtoDetails}
     * @memberof IOcrLockboxAggregatorDto
     */
    details?: IOcrLockboxDtoDetails;
}

/**
 * Check if a given object implements the IOcrLockboxAggregatorDto interface.
 */
export function instanceOfIOcrLockboxAggregatorDto(value: object): value is IOcrLockboxAggregatorDto {
    return true;
}

export function IOcrLockboxAggregatorDtoFromJSON(json: any): IOcrLockboxAggregatorDto {
    return IOcrLockboxAggregatorDtoFromJSONTyped(json, false);
}

export function IOcrLockboxAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrLockboxAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birth_date'] == null ? undefined : json['birth_date'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'address': json['address'] == null ? undefined : IAddressFromJSON(json['address']),
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'details': json['details'] == null ? undefined : IOcrLockboxDtoDetailsFromJSON(json['details']),
    };
}

export function IOcrLockboxAggregatorDtoToJSON(json: any): IOcrLockboxAggregatorDto {
    return IOcrLockboxAggregatorDtoToJSONTyped(json, false);
}

export function IOcrLockboxAggregatorDtoToJSONTyped(value?: IOcrLockboxAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_name': value['employee_name'],
        'account_number': value['account_number'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'birth_date': value['birth_date'],
        'amount': value['amount'],
        'address': IAddressToJSON(value['address']),
        'claim_ids': value['claim_ids'],
        'details': IOcrLockboxDtoDetailsToJSON(value['details']),
    };
}

